import { useMemo } from 'react';

export const cursorPointerStyle = { cursor: 'pointer' };
